import React from 'react';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';

interface Props {
  testId?: string;
  tabsCount?: number;
}

export const TabsLoader = ({ testId = 'tabs-loader', tabsCount = 3 }: Props) => {
  return (
    <div data-testid={testId}>
      <SkeletonLoaderWrapper>
        {Array.from({ length: tabsCount }).map((_, index) => (
          <SkeletonLoader key={index} width="10%" marginBottom="8px" marginRight="1rem" />
        ))}
        <SkeletonLoader width="100%" height="1px" />
      </SkeletonLoaderWrapper>
    </div>
  );
};
